module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "registerSettlementForm"
  }, [_c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": "Корисничко измирење фактура",
      "alternativeRoute": "invoices/user-settlement"
    }
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Датотека са фактурама"
    }
  }, [_c('b-form-file', {
    ref: "settlementFileForm",
    attrs: {
      "accept": ".csv, .json",
      "no-drop": "",
      "browse-text": "Претражи",
      "placeholder": "Датотека није одабрана "
    },
    on: {
      "change": _vm.fileLoaded
    },
    model: {
      value: (_vm.settlementData),
      callback: function($$v) {
        _vm.settlementData = $$v
      },
      expression: "settlementData"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.loadedSettlementData) ? _c('b-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": "",
      "header-bg-variant": "success",
      "header": "Проверите податке о измирењу",
      "header-text-variant": "white"
    }
  }, [_c('div', [_c('b-list-group', [_c('b-table', {
    attrs: {
      "sticky-header": "",
      "striped": "",
      "hover": "",
      "items": _vm.loadedSettlementData
    }
  })], 1)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.errorList), function(error) {
    return _c('b-list-group-item', {
      key: error.settlement.invoiceId
    }, [_vm._v(_vm._s(error.settlement.invoiceId) + " - " + _vm._s(_vm.$t('apiStatusCodes.' + error.settlementError.code)))])
  }), 1)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.parsedSettlementData) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-modal', {
    ref: "settleInvoiceModal",
    attrs: {
      "no-title": "",
      "ok-title": _vm.$t('forms.submit'),
      "ok-only": ""
    },
    on: {
      "ok": function($event) {
        return _vm.submitSettlement(false)
      }
    }
  }, [_c('b-alert', {
    staticClass: "mb-0",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceUserSettle')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\r\n                        Да ли сте сигурни да желите да покренете корисничко измирење " + _vm._s(_vm.parsedSettlementData.length) + " фактура(e).\r\n                        ")])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.load || !_vm.loadedSettlementData
    },
    on: {
      "click": function($event) {
        return _vm.submitSettlement(true)
      }
    }
  }, [_vm._v("\r\n                Валидирај измирење\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "warning",
      "disabled": _vm.load || !_vm.loadedSettlementData
    },
    on: {
      "click": _vm.confirmSettlement
    }
  }, [_vm._v("\r\n                Региструј измирење\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-211b1af0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-211b1af0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/home/user-settlements/user-settlements.html
// module id = 775
// module chunks = 1